"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeContainer = exports.useIsEnterprisePlan = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var useIsEnterprisePlan = function () {
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var accountDataStore = rootDataStore.getAccountDataStore();
    return accountDataStore === null || accountDataStore === void 0 ? void 0 : accountDataStore.getPlanInternalName().startsWith("enterprise");
};
exports.useIsEnterprisePlan = useIsEnterprisePlan;
var UpgradeContainer = function (_a) {
    var children = _a.children;
    var isEnterprisePlan = (0, exports.useIsEnterprisePlan)();
    if (isEnterprisePlan)
        return null;
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.UpgradeContainer = UpgradeContainer;
